export const Duration = {
  fast: "0.15s",
  standard: "0.2s",
  emphasized: "0.28s",
} as const;

export const Easing = {
  standard: "ease",
  emphasized: "cubic-bezier(0.2, 0.8, 0.2, 1)",
} as const;
